exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".edit-row--link[data-v-6f48eb30] {\n  position: relative;\n  padding: 16px 8px 0;\n  border-radius: 4px;\n}\n.overline[data-v-6f48eb30] {\n  margin-bottom: 4px;\n}\n[data-v-6f48eb30] .hover-links .edit {\n  display: none;\n}\n", ""]);

// exports
